export default __webpack_public_path__ + "static/media/logout-gestalt.8972a9db.svg";